if (!customElements.get('amaca-catalog')) {
  customElements.define('amaca-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const form = this.querySelector('form');
      const open = this.querySelector('[data-open]');
      const media = window.matchMedia('(min-width: 990px), (max-width: 749px)');
      open.addEventListener('click', () => { if (media.matches) dialog.showModal(); });
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      this.onMediaChange = () => { if (!media.matches && dialog.open) dialog.close(); };
      media.addEventListener('change', this.onMediaChange);
      this.media = media;
      for (const group of ['amaca_category', 'amaca_color']) {
        if (!form.querySelector(`input[name="${group}"]:checked`)) {
          const empty = form.querySelector(`input[name="${group}"][value=""]`);
          if (empty) empty.checked = true;
        }
      }
      const active = new URLSearchParams(window.location.search);
      this.querySelectorAll('[data-remove-tag]').forEach(link => {
        const url = new URL(link.href);
        url.search = active.toString();
        url.searchParams.delete('page');
        link.href = url.href;
      });
      const gender = this.dataset.selectedGender || 'all';
      this.querySelectorAll('[data-audience]').forEach(link => {
        const url = new URL(link.href);
        url.search = active.toString();
        url.searchParams.delete('page');
        link.href = url.href;
      });
      if (gender !== 'all') {
        this.querySelectorAll('.amaca-catalog-nav a, .amaca-catalog-category-link').forEach(link => {
          const url = new URL(link.href);
          url.pathname = url.pathname.replace(/\/$/, '') + '/' + gender;
          for (const [key, value] of active) {
            if (key.startsWith('filter.') || key === 'sort_by') url.searchParams.append(key, value);
          }
          link.href = url.href;
        });
      }
      const appliedCount = this.querySelectorAll('[data-tag]:checked:not([value=""])').length +
        [...active.keys()].filter(key => key.startsWith('filter.')).length + (gender === 'all' ? 0 : 1);
      let count = this.querySelector('.amaca-catalog-filter-count');
      if (appliedCount && !count) {
        count = document.createElement('span');
        count.className = 'amaca-catalog-filter-count';
        open.append(count);
      }
      if (count) count.textContent = appliedCount ? `(${appliedCount})` : '';
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!media.matches) return;
        const data = new FormData(form);
        const tags = [...form.querySelectorAll('[data-tag]:checked')].map(input => input.value).filter(Boolean);
        if (gender !== 'all') tags.push(gender);
        const url = new URL(this.dataset.collectionUrl + (tags.length ? '/' + tags.join('+') : ''), window.location.origin);
        for (const [key, value] of data) {
          if (!key.startsWith('amaca_') && value !== '') url.searchParams.append(key, value);
        }
        window.location.assign(url.href);
      });
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.onMediaChange); this.ready = false; }
  });
}
